import { render, staticRenderFns } from "./BackArrow.vue?vue&type=template&id=5d58d752&scoped=true"
var script = {}
import style0 from "./BackArrow.vue?vue&type=style&index=0&id=5d58d752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58d752",
  null
  
)

export default component.exports